import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetShift = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_SHIFT_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetShiftAction({
                    data: data.data,
                    countPage: data.countPage
                }))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetShift as SetGetShift
}